import { type ReactElement } from "react";
import { sidebarData } from "@/data";
import { useScrollSpy } from "@/hooks";
import { useDarkMode, useLanguage } from "@/context";
import { t, type TranslationKey } from "@/data";

const SECTION_IDS = sidebarData.map((item) => item.path.replace("/#", ""));

const NAV_LABELS: Record<string, TranslationKey> = {
  hero: "navHome",
  projects: "navProjects",
  aboutMe: "navAboutMe",
  skills: "navSkills",
};

export const Navbar = (): ReactElement => {
  const activeId = useScrollSpy(SECTION_IDS);
  const { modeClass } = useDarkMode();
  const { lang } = useLanguage();

  return (
    <nav className={`navbar ${modeClass}`} aria-label={t(lang, "sectionNav")}>
      {sidebarData.map((item) => {
        const sectionId = item.path.replace("/#", "");
        const isActive = activeId === sectionId;
        return (
          <a
            key={item.path}
            href={item.path}
            className={`navbar-item${isActive ? " active" : ""}`}
            aria-label={t(lang, NAV_LABELS[sectionId])}
            aria-current={isActive ? "true" : undefined}
          >
            {item.icon}
          </a>
        );
      })}
    </nav>
  );
};
